import Helper from '../lib/Helper';

export default {
	_bodySelector    : '[data-entry-body]',
	_itemSelector    : '[data-dynamic-font-wrapper]',
	_titleSelector   : '[data-dynamic-font-size]',
	_body            : null,
	_items           : null,
	_titles          : [],
	_minimumFontSize : 22,
	init() {
		this._items = document.querySelectorAll(this._itemSelector);
		if (!this._items.length) {
			return;
		}
		this._body = document.querySelector(this._bodySelector);
		Array.prototype.forEach.call(this._items, item => {
			let title = item.querySelector(this._titleSelector);
			if (title) {
				this._titles.push(title);
				this._adjustFontSize(title);
			}
		});
		this._onOrientationChange();
		window.addEventListener('resize', this._onOrientationChange.bind(this));
	},
	_onOrientationChange() {
		if (!this._titles.length) {
			return;
		}
		/* Need a small delay here to ensure that we get the correct window-size */
		setTimeout(() => {
			Array.prototype.forEach.call(this._titles, title => {
				title.removeAttribute('style');
				this._adjustFontSize(title);
			});
		});
	},
	_adjustFontSize(element) {
		const width            = element.clientWidth;
		let actualWidth        = element.scrollWidth;
		if (actualWidth < width) {
			return;
		}
		const styles = window.getComputedStyle(element, null);
		let fontSize = parseFloat(styles.getPropertyValue('font-size'));
		while (actualWidth > width && fontSize >= this._minimumFontSize) {
			element.style.fontSize = `${--fontSize}px`;
			actualWidth            = element.scrollWidth;
		}
	}
};